import script from "./BackButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BackButton.vue?vue&type=script&setup=true&lang=js"

import "./BackButton.vue?vue&type=style&index=0&id=1d1d76ae&lang=scss"

const __exports__ = script;

export default __exports__